// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results{display:flex;justify-content:center;text-align:center;color:#104182;height:5rem;margin:0 0 -5px 0;padding-left:8px}.results .icon{flex:1 0 auto;margin:0 3% 2px;font-size:2em;align-self:center}.results .nb{flex:1 0 auto;font-size:1em;align-self:center}@media (max-width: 1000px){.results .nb{font-size:0.9em}}\n", ""]);
// Exports
module.exports = exports;
